<template>
  <el-dialog :visible.sync="visible" :title="title" :width="width" @close="handleClose" :modal-append-to-body="false">
    <template v-if="$slots.header">
      <slot name="header"></slot>
    </template>
    <div v-else>
      <h3>{{ title }}</h3>
    </div>

    <div class="content">
      <slot></slot>
    </div>

    <div class="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
    <div class="footer" v-else>
      <div class="footer-buttons">
        <el-button v-if="showCancelButton" :size="cancelButtonSize" :type="cancelButtonType" :class="cancelButtonClass"
          @click="handleCancel">{{ cancelButtonText }}</el-button>
        <el-button v-if="showConfirmButton" :size="confirmButtonSize" :type="confirmButtonType"
          :class="confirmButtonClass" @click="handleConfirm">{{ confirmButtonText }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<style>
.footer {
  display: flex;
  justify-content: flex-end;
}

.footer-buttons {
  margin-left: auto;
  display: flex;
  gap: 10px;
}
</style>

<script>

export default {
  name: 'ElementDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '50%'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    confirmButtonText: {
      type: String,
      default: '确认'
    },
    cancelButtonSize: {
      type: String,
      default: 'medium'
    },
    confirmButtonSize: {
      type: String,
      default: 'medium'
    },
    cancelButtonType: {
      type: String,
      default: 'default'
    },
    confirmButtonType: {
      type: String,
      default: 'primary'
    },
    cancelButtonClass: {
      type: String,
      default: ''
    },
    confirmButtonClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>
